import { BaseGenerator, prompts, chalk, clackPrompts, fsExtra, yParser } from '@umijs/utils';
import { join } from 'path';
import { version } from '../package.json';
const cwd = process.cwd()
const { isCancel, text, select, intro, outro } = clackPrompts;
/**
 * @功能 ：脚手架设计模板(Scaffold design template)
 * @flows:
 * 1.set Floder Name of App 
 * 2.select App Template
 *  2.1 create UI Project Template
 *  2.2 create Pligin Template(select)
 *   2.2.1 create Runtime Plugin Template
 *   2.2.2 create Compile Time Plugin
 *  2.3 create Material Template
 * **/
interface IDefaultData {
  projName: string,
  author: string,
  version: string,
  appTemplate: ETemplate.app,
}
enum ETemplate {
  app = 'app',
  plugin = 'plugin',
  material = 'material',
  runtimePlugin = 'runtimePlugin',
  compilePlugin = 'compilePlugin'
}

const DEFAULT_DATA = {
  projName: 'parch-proj-demo',
  author: '',
  version: version,
  appTemplate: ETemplate.app
} satisfies IDefaultData;

const initScaffoldFlows = async function (opt) {
  let appTemplate = opt.defaultData?.appTemplate || ETemplate.app;
  let [name] = opt.args._;
  let target = name ? join(cwd, name) : cwd;
  const useDefaultData = !!opt.args.default;
  const setAppName = async function () {
    name = (await text({
      message: "What's the proj folder name?",
      initialValue: name || 'my-app',
      validate: (value: string) => {
        if (!value.length) {
          return 'Please input project name';
        }
        if (value != '.' && fsExtra.existsSync(join(cwd, value))) {
          return `Folder ${value} already exists`;
        }
      },
    })) as string;

  }
  const selectAppTemplate = async function () {
    appTemplate = (await select({
      message: 'Pick Parch App Template',
      options: [
        {
          label: 'UI Design App',
          value: ETemplate.app,
          hint: 'for ui design app development',
        },
        {
          label: 'Parch Material',
          value: ETemplate.material,
          hint: 'for material development'
        },
        {
          label: 'Parch Plugin',
          value: ETemplate.plugin,
          hint: 'for plugin development',
        },
      ],
      initialValue: ETemplate.app,
    })) as ETemplate;
  }
  const createTemplateFiles = async () => {
    const questions: prompts.PromptObject[] = [
      {
        name: 'name',
        type: 'text',
        message: `Input NPM package name (eg: example-proj)`,
      },
      {
        name: 'description',
        type: 'text',
        message: `Input project description`,
      },
      {
        name: 'author',
        type: 'text',
        message: `Input project author (Name <email@example.com>)`,
      },
    ];
    console.log(`aaa:target:${target}`, `path:${join(__dirname, '..', 'templates', appTemplate)}`)
    const generator = new BaseGenerator({
      path: join(__dirname, '..', 'templates', appTemplate),
      target,
      slient: true,
      data: useDefaultData
        ? opt.defaultData
        : ({
          version: version,
        }),
      questions
    });
    await generator.run();
  };

  const createUIPojTemp = async function () { }

  const createPluginTemp = async function () {
    appTemplate = (await select({
      message: 'Pick Runtimetime Plugin Template',
      options: [
        {
          label: 'Runtime Plugin',
          value: ETemplate.runtimePlugin,
          hint: 'for Runtime Plugin development',
        },
        {
          label: 'Compile Plugin',
          value: ETemplate.compilePlugin,
          hint: 'for Compile Plugin development'
        }
      ],
      initialValue: ETemplate.runtimePlugin,
    })) as ETemplate;
    // switch (opt.pluginType) {
    //   case 'runtime':
    //     await createRuntimePluginTemp(opt.tempOpts)
    //     break
    //   case 'compile':
    //     await createCompilePluginTemp(opt.tempOpts)
    //     break
    //   default:
    //     console.warn('unknown Plugin Type')
    //     break
    // }

  }
  const createRuntimePluginTemp = async function () { }
  const createCompilePluginTemp = async function () { }
  const createMaterialTemp = async function () { }

  const exitPrompt = () => {
    outro(chalk.red('Exit create-umi'));
    process.exit(1);
  };

  await setAppName()
  if (isCancel(name)) {
    exitPrompt()
  }
  target = join(cwd, name)
  await selectAppTemplate()
  if (isCancel(appTemplate)) {
    exitPrompt()
  }
  debugger
  switch (appTemplate) {
    case 'app':
      console.log('create UI Project Template')
      break
    case 'plugin':
      console.log('create Plugin Template')
      await createPluginTemp()
      break
    case 'material':
      console.log('create Material Template')
      await createMaterialTemp()
      break
    default: console.warn('unkonwn Proj Type')
      break
  }
  await createTemplateFiles()
}


const run = async function ({
  cwd,
  args,
  defaultData = DEFAULT_DATA
}: {
  cwd: string;
  args: any;
  defaultData?: IDefaultData;
}) {
  await initScaffoldFlows({ defaultData, args, cwd })
}


const args = yParser(process.argv.slice(2), {
  alias: {
    version: ['v'],
    help: ['h'],
  },
  boolean: ['version'],
});
run({
  cwd: process.cwd(),
  args
})